var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 52.9231H496V16H16V52.9231V52.9231Z",
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 89.8459H496V52.9229H16V89.8459V89.8459Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 126.769H496V89.8457H16V126.769V126.769Z",
    fill: "#E74C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 163.692H496V126.769H16V163.692V163.692Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 200.615H496V163.692H16V200.615V200.615Z",
    fill: "#E74C3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 237.538H496V200.615H16V237.538V237.538Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 274.461H496V237.538H16V274.461V274.461Z",
    fill: "#E74C3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 311.384H496V274.461H16V311.384V311.384Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 348.308H496V311.385H16V348.308V348.308Z",
    fill: "#E74C3C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16 385.231H496V348.308H16V385.231V385.231Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16 422.154H496V385.23H16V422.154V422.154Z",
    fill: "#E74C3C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 459.076H496V422.153H16V459.076V459.076Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16 496H496V459.077H16V496V496Z",
    fill: "#E74C3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M256 16H16V311.998H256V16Z",
    fill: "#3C3B6E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.694 97.04C74.4471 97.04 45.8386 127.039 45.8386 164C45.8386 200.96 74.4471 230.96 109.694 230.96C122.429 230.96 134.293 227.039 144.258 220.294C138.455 222.401 132.228 223.554 125.744 223.554C94.4895 223.554 69.1235 196.955 69.1235 164.18C69.1235 131.406 94.4895 104.807 125.744 104.807C132.651 104.807 139.268 106.105 145.389 108.483C135.198 101.261 122.912 97.04 109.694 97.04V97.04Z",
    fill: "#FFCC00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M215.59 198.858L188.692 184.093L196.645 214.311L178.654 189.033L173.042 219.8L167.522 189.016L149.455 214.237L157.499 184.043L130.556 198.723L150.571 175.101L120.089 176.333L148.11 163.96L120.127 151.499L150.604 152.827L130.661 129.142L157.559 143.907L149.606 113.689L167.597 138.967L173.209 108.2L178.73 138.984L196.796 113.763L188.752 143.957L215.695 129.277L195.68 152.899L226.162 151.667L198.141 164.04L226.124 176.501L195.647 175.173L215.59 198.858Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/MY.86f0d06103f799259e4f0f72721c7829.svg";
export { ForwardRef as ReactComponent };